import { cn } from '@/utils/cn'
import type { HTMLAttributes } from 'react'

export const StatusMessage = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 text-center text-body-foreground text-xs lg:my-5',
        '[&_h6]:mt-1 [&_h6]:font-semibold [&_h6]:text-base [&_h6]:text-heading-foreground',
        className
      )}
      {...props}
    />
  )
}
